import { createReducer, on } from '@ngrx/store';
import {
  RESELLER_FIND_SUCCESS,
  RESELLER_FAILURE,
  RESELLER_UPDATE_FORM,
  RESELLER_RESET_ERROR,
  RESELLER_RESET,
  RESELLER_RESET_FORM,
  RESELLER_FIND_ALL_SUCCESS,
  RESELLER_EDIT_MODE,
  RESELLER_UPDATE_ID,
  RESELLER_UPDATE_LOADING,
  RESELLER_CLEAR_STATE
} from '@store/actions';
import { ResponseBadRequest } from '@core/interfaces';
import {
  Revendedor,
  RevendedorForm,
} from '@core/models';

export interface ResellerState {
  loading: boolean;
  editMode: boolean;
  isEditing: boolean;
  reseller: Revendedor | null;
  resellerList: Revendedor[] | null;
  resellerForm: RevendedorForm | null;
  resellerId: string | null;
  error: ResponseBadRequest | null;
}

export const initialState: ResellerState = {
  loading: false,
  editMode: false,
  isEditing: false,
  reseller: null,
  resellerList: null,
  resellerForm: null,
  resellerId: null,
  error: null,
};
export const resellerReducer = createReducer(
  initialState,
  on(RESELLER_EDIT_MODE, (state, { editMode, isEditing }) => ({ ...state, editMode, isEditing })),
  on(RESELLER_FIND_SUCCESS, (state, { reseller }) => ({ ...state, reseller })),
  on(RESELLER_FIND_ALL_SUCCESS, (state, { resellerList }) => ({ ...state, resellerList })),
  on(RESELLER_FAILURE, (state, { error }) => ({ ...state, error })),
  on(RESELLER_UPDATE_FORM, (state, { resellerForm }) => ({ ...state, resellerForm })),
  on(RESELLER_RESET, (state) => ({ ...state, reseller: initialState.reseller })),
  on(RESELLER_RESET_ERROR, (state) => ({ ...state, error: initialState.error })),
  on(RESELLER_RESET_FORM, (state) => ({ ...state, resellerForm: initialState.resellerForm, loading: initialState.loading })),
  on(RESELLER_UPDATE_ID, (state, { resellerId }) => ({ ...state, resellerId })),
  on(RESELLER_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(RESELLER_CLEAR_STATE, () => initialState),
);
